
import { CustomerConfiguration, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { updateCustomerConfiguration, getCustomerConfiguration } from "../../Requests/Configuration.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";

export const initialState = new State(new RequestedValue$1(0, []), FormState_get_empty());

export function init() {
    return [initialState, getCustomerConfiguration((Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 2: {
            const matchValue_1 = state.CustomerConfiguration;
            if (matchValue_1.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, updateCustomerConfiguration(matchValue_1.fields[0], (Item) => (new Msg(4, [Item])), (Item_1) => (new Msg(5, [Item_1])))];
            }
        }
        case 0:
            return [state, updateCustomerConfiguration(msg.fields[0], (Item_2) => (new Msg(4, [Item_2])), (Item_3) => (new Msg(5, [Item_3])))];
        case 3:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), state.FormState), Cmd_none()];
        case 4: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                const validationResponse = response_1.fields[0];
                let globalValidationToast;
                const matchValue_2 = validationResponse.GlobalValidationMessage;
                globalValidationToast = ((matchValue_2 == null) ? Cmd_none() : Cmd_errorToast(matchValue_2));
                return [new State(state.CustomerConfiguration, FormState__setValidationResponse_5219762A(state.FormState, validationResponse)), Cmd_batch(ofArray([globalValidationToast, getCustomerConfiguration((Item_6) => (new Msg(3, [Item_6])), (Item_7) => (new Msg(5, [Item_7])))]))];
            }
            else {
                return [new State(state.CustomerConfiguration, FormState_get_empty()), Cmd_batch(ofArray([Cmd_successToast("settings.permissions_changed_successful"), getCustomerConfiguration((Item_4) => (new Msg(3, [Item_4])), (Item_5) => (new Msg(5, [Item_5])))]))];
            }
        }
        case 5:
            return [state, Cmd_none()];
        default: {
            const matchValue = state.CustomerConfiguration;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const customerConfiguration = matchValue.fields[0];
                return [new State(new RequestedValue$1(1, [new CustomerConfiguration(customerConfiguration.Staging, customerConfiguration.IsGlobalAppSearchActiveForUserRole, customerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification, customerConfiguration.IsSelfServiceReservationForUserActive, msg.fields[0], customerConfiguration.NotificationEmailsOnlyToAdministrators, customerConfiguration.DemoDataImported, customerConfiguration.CanUserSeeAllTools, customerConfiguration.CanUserWriteNotices, customerConfiguration.AppVisibilityPermissionReceiver, customerConfiguration.GlobalSelfServiceStorageActive, customerConfiguration.CustomI18nextNamespace, customerConfiguration.Tenants, customerConfiguration.TenantName, customerConfiguration.ReceiverCreateReservationAllowedConfiguration, customerConfiguration.AllowUserToUserAssignmentViaUserSelection, customerConfiguration.IsUserToUserTransferSignatureRequired, customerConfiguration.IsReturnTransferSignatureRequired, customerConfiguration.IsReleaseDateEnabled, customerConfiguration.ToolManagerCanCreateReceiver, customerConfiguration.ToolManagerCanArchiveReceiver, customerConfiguration.SSOConfiguration, customerConfiguration.InventoryConfiguration, customerConfiguration.ProtocolConfiguration, customerConfiguration.AppLogoConfiguration, customerConfiguration.ReservationConfiguration, customerConfiguration.Currency, customerConfiguration.ChatActive, customerConfiguration.CompletedOnboardingTourSteps)]), state.FormState), Cmd_none()];
            }
        }
    }
}

